module.exports = __webpack_public_path__ + "img/notes.627c9aed.svg";